module.exports = __webpack_public_path__ + "img/selected2-min.e5d73a2a.png";